import adicionalRouters from '@/modules/outros/adicional/router';
import entradaRouters from '@/modules/estoque/entrada/router';
import contagemEstoqueRouters from '@/modules/estoque/contagemEstoque/router';
import transferenciaRouters from '@/modules/estoque/transferencia/router';
import gourmetRouters from '@/modules/outros/gourmet/router';
import feriadoRouters from '@/modules/configuracoes/feriado/router';
import davReportRouters from '@/modules/configuracoes/davReport/router';
import kitRouters from '@/modules/outros/kit/router';
import importarArquivoTextoRouter from '@/modules/outros/importarArquivoTexto/router';

export default [
  ...adicionalRouters,
  ...entradaRouters,
  ...contagemEstoqueRouters,
  ...transferenciaRouters,
  ...gourmetRouters,
  ...feriadoRouters,
  ...davReportRouters,
  ...kitRouters,
  ...importarArquivoTextoRouter,
];
